import {
  QueryModel,
  UseQueryParamsProps,
  UseQueryParamsReturn,
  useQueryParams,
} from '@domonda/query-params';
import { GetReleasableInvoiceContainersParams } from 'lib/api/invoiceContainers';

export type ReleaseOverviewQueryParams = GetReleasableInvoiceContainersParams;

export const releaseOverviewModel: QueryModel<ReleaseOverviewQueryParams> = {
  documentState: {
    type: 'string',
    defaultValue: 'validated',
    validate: (value) => {
      switch (value) {
        case 'validated':
        case 'autoprocessed':
          return true;
      }
      return false;
    },
  },
};

export function useReleaseOverviewQueryParams(
  props?: UseQueryParamsProps,
): UseQueryParamsReturn<ReleaseOverviewQueryParams> {
  const [params, setParams] = useQueryParams(releaseOverviewModel, props);
  return [params, setParams];
}
